export default __webpack_public_path__ + "resources/icons/n110-dc0f.webp";